<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <!--<breadcrumb :title="title" :path="path" :text="text" :text1="text1" :search_data="searchform" :columns="originalColumn" /> -->

        <reports-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :search_data="searchform"
          :columns="originalColumn"
          :hasExportPermission="hasExportPermission"
        />

        <!-- /Page Header -->
        <!-- Search Filter -->
        <!-- <attendance-reports-filter /> -->
        <Form @submit="onSearch">
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3" v-if="hasWritePermission">
              <div class="input-block mb-3 form-focus focused">
                <vue-select
                  :options="employee_list"
                  id="projectreportname"
                  v-model="searchform.s_employee_id"
                  placeholder="-"
                />

                <label class="focus-label">Employee Name</label>
              </div>
            </div>
			<div class="col-sm-6 col-md-2" v-if="hasWritePermission">
              <div class="input-block mb-3 form-focus focused">
                <vue-select
                  :options="leavedef_list"
                  id="leavetypeselect"
                  v-model="searchform.s_leave_definition_id"
                  placeholder="-"
                />

                <label class="focus-label">Leave Type</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Year"
                  id="year"
                  placeholder="-"
                  v-model="searchform.year"
                />
                <label class="focus-label">Select Year</label>
              </div>
            </div>
			
            <div class="col-sm-6 col-md-2">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Month"
                  id="month"
                  placeholder="-"
                  v-model="searchform.month"
                />
                <label class="focus-label">Select Month</label>
              </div>
            </div>
			<div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
              <!--<a href="javascript:;" class="btn btn-success w-100"> Search </a> -->
              <button class="btn btn-success w-100 submit-btn">Search</button>
              <a
                href="javascript:;"
                class="btn btn-danger w-100 submit-btn mt-2"
                @click="clearForm"
              >
                Clear
              </a>
            </div>
            <!--<div class="col-sm-6 col-md-2">
              <div class="d-grid">
                <button class="btn btn-success w-100 mb-3 submit-btn">
                  Search
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="d-grid">
                <a
                  href="javascript:void(0)"
                  class="btn btn-danger w-100 submit-btn"
                  @click="clearForm"
                  >Clear</a
                >
              </div>
            </div>-->
          </div>
        </Form>

        <!-- /Search Filter -->
        <div class="row">
          <div class="col-md-12">
            <!--
            <div class="showentries mb-3">
              <label
                >Show
                <select v-model="pagination.pageSize" @change="updatePerPage">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div> -->
            <div class="table-responsive">
              <a-table
                class="stripped table-hover"
                :columns="originalColumn"
                :data-source="data2"
                :pagination="false"
              >
                <template #bodyCell="{ index, column, record }">
                  <template v-if="column.key === 'Id'">
                    <div>
                      {{ index + 1 }}
                    </div>
                  </template>
				  <template v-if="column.key === 'year'">
                    <div>{{ tableyear  }}</div>
                  </template>
				  <template v-if="column.key === 'month'">
                    <div>{{ tablemonth  }}</div>
                  </template>
                  <template v-if="column.key === 'leavetype'">
                    <div>{{ record.leave_type  }}</div>
                  </template>
                  <template v-if="column.key === 'ClockIn'">
                    <div class="punch-time">
                      <span
                        v-if="getPunchStatus(record, 'in').isEdited"
                        title="Edited"
                      >
                        <i class="fa fa-pencil-alt"></i>
                      </span>
                      <span
                        v-html="
                          getAuthIcon(
                            getPunchStatus(record, 'in').authType,
                            getPunchStatus(record, 'in').actionby
                          )
                        "
                      ></span>
                      {{ record.firstpunchtz }}
                    </div>
                  </template>
                  <template v-if="column.key === 'ClockOut'">
                    <div class="punch-time">
                      <span
                        v-if="getPunchStatus(record, 'out').isEdited"
                        title="Edited"
                      >
                        <i class="fa fa-pencil-alt"></i>
                      </span>
                      <span
                        v-html="
                          getAuthIcon(
                            getPunchStatus(record, 'out').authType,
                            getPunchStatus(record, 'out').actionby
                          )
                        "
                      ></span>
                      {{ record.lastpunchtz }}
                    </div>
                  </template>
                  <!-- <template v-if="column.key === 'Timezone'">
                    <div>{{ record.timezone }}</div>
                  </template> -->
                  <template v-if="column.key === 'TotalHours'">
                    <div>{{ formattedTime(record.total_hours) }}</div>
                  </template>
                  <template v-if="column.key === 'TotalShiftHours'">
                    <div>
                      {{ formattedTime(record.total_production_hours) }}
                    </div>
                  </template>
                  <template v-if="column.key === 'BreakTime'">
                    <div>{{ formattedTime(record.total_break_hours) }}</div>
                  </template>
                  <template v-if="column.key === 'WorkStatus'">
                    <div v-if="record.is_holiday == 1">Holiday</div>
                    <div v-else-if="record.is_leave == 1">
                      {{ record.leave_type }}
                    </div>
                    <div v-else-if="record.isfuture == 1"></div>
                    <div v-else-if="record.total_hours <= 0">Absent</div>
                    <div v-else-if="record.total_hours >= 5">Full Day</div>
                    <div
                      v-else-if="
                        record.total_hours > 0 && record.total_hours < 5
                      "
                    >
                      Half Day
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
    </div>

    <div
      id="attendance_report_manage_colvis"
      class="modal custom-modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Manage Column Visibility</h5>
            <!-- <small>select the column from the default that you want to hide</small> -->
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="modal_team_information_close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-6"
                v-for="(column, key) in columns_"
                :key="column.key"
              >
                <div class="input-block mb-3 d-flex">
                  <div class="form-switch" style="margin-right: 5px">
                    <input
                      v-model="column.visibility"
                      type="checkbox"
                      class="form-check-input"
                      :id="'customSwitch_' + column.key"
                      value="false"
                      :checked="column.visibility"
                    />
                  </div>
                  <label class="col-form-label"> {{ column?.title }} </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Update leave_report_manage_colvis Modal -->

    <!-- /Page Wrapper -->
  </div>
</template>
<script>
var pagination = { total: 0, current: 1, pageSize: 10 };
import axios from "axios";
import { notification } from "ant-design-vue";
import { Form } from "vee-validate";
const columns = [
  {
    title: "Sr No.",
    dataIndex: "Id",
    key: "Id",
    sorter: false,
    visibility: true,
  },
  {
    title: "Leave Type",
    dataIndex: "leavetype",
    key: "leavetype",
    sorter: false,
    visibility: true,
  },
  {
    title: "Year",
    dataIndex: "year",
    key: "year",
    sorter: false,
    visibility: true,
  },
  {
    title: "Month",
    dataIndex: "month",
    key: "month",
    sorter: false,
    visibility: true,
  },
  {
    title: "Entitled Days",
    dataIndex: "entitled_days",
    key: "entitled_days",
    sorter: false,
    visibility: true,
  },
  {
    title: "Used Days",
    dataIndex: "used_days",
    key: "used_days",
    sorter: false,
    visibility: true,
  },
  {
    title: "Carry Over Days",
    dataIndex: "carry_over_days",
    key: "carry_over_days",
    sorter: false,
    visibility: true,
  },
  {
    title: "Encashed Days",
    dataIndex: "encashed_days",
    key: "encashed_days",
    sorter: false,
    visibility: true,
  },
  {
    title: "Pending Leaves",
    dataIndex: "pending_leaves",
    key: "pending_leaves",
    sorter: false,
    visibility: true,
  },
];
const data = [];

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.toLocaleString("default", { month: "short" });

export default {
  components: {
    Form,
  },
  data() {
    // const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= 2020; year--) {
      years.push(year.toString());
    }

    return {
      title: "Leave Reports",
      path: "Dashboard",
      text: "Leave Reports",
      text1: "Export Excel",
      columns,
      data,
      pagination: pagination,
      employee_list: [],
      leavedef_list: [],
      select2: null,
      Month: [
        "-",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      Year: ["-", ...years],
      searchform: { s_employee_id: "", s_leave_definition_id : "", month: "", year: "" },
      AttendanceMonth: ["Jan", "Feb", "Mar"],
      AttendanceYear: ["2023", "2023", "2023"],
      employeeName: "",
      isFocused: false,
      data2: [],
      columns_: columns,
      hasReadPermission: null,
      hasWritePermission: null,
      hasExportPermission: null,
	  tableyear: "",
	  tablemonth: "",
    };
  },
  name: "attendance-reports",
  methods: {
    getAuthIcon(authType, actionby) {
      if (!authType) return null;

      const type = authType.toLowerCase();
      if (type.includes("face")) {
        return '<i class="fas fa-user-circle"></i>'; // Face icon
      } else if (type.includes("pin")) {
        if (actionby) {
          const imageUrl = '${process.env.VUE_APP_IMAGE_BASE_URL}${actionby}';
          return '<span class="image-container"><a href="#" class="pin-icon" data-imageurl="${imageUrl}"><i class="fas fa-key"></i></a><span class="no-image-fallback" style="display: none"><i class="fas fa-key"></i> <small>×</small> </span></span>';
        }
        return '<i class="fas fa-key"></i>';
      } else if (type.includes("otp")) {
        return '<i class="fas fa-mobile-alt"></i>'; // OTP icon
      }
      return null;
    },
    getPunchStatus(record, punchType) {
      if (!record.punchingdetails || !record.punchingdetails.length)
        return { authType: null, isEdited: false };

      let punch = null;
      if (punchType === "in") {
        punch = record.punchingdetails.find((p) => p.punch_type === "punch-in");
      } else {
        const punchOuts = record.punchingdetails.filter(
          (p) =>
            p.punch_type === "punch-out" &&
            p.punch_out_reason === "Final Punch Out"
        );
        punch = punchOuts.length ? punchOuts[punchOuts.length - 1] : null;
      }

      return {
        authType: punch?.auth_type || null,
        isEdited: punch?.is_edited === 1,
        actionby: punch?.actionby,
      };
    },
    handleImageClick(imageUrl) {
      const img = new Image();

      img.onload = () => {
        window.open(imageUrl, "_blank");
      };
      img.onerror = () => {
        notification.open({
          message: "Image Not Found",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
      };
      img.src = imageUrl;
    },
    formattedTime(gethours) {
      var totalMinutes = gethours * 60;
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      minutes = minutes.toFixed(0);
      return `${hours}h ${minutes}m`;
    },
    clearForm() {
      this.searchform = { s_employee_id: "", s_leave_definition_id : "", month: "", year: "" };
      // this.pagination.current = 1;

      if (this.hasWritePermission) {
        this.data2 = [];
        // this.pagination.total = 0;
      } else {
        this.searchform = {
          s_employee_id: "",
          month: currentMonth,
		  s_leave_definition_id : "",
          year: currentYear.toString(),
        };
        this.loadCommonData({
          params: {
            s_employee_id: this.searchform.s_employee_id,
			s_leave_definition_id : this.searchform.s_leave_definition_id,
            month: this.searchform.month,
            year: this.searchform.year,
            // page: this.pagination.current,
            // per_page: this.pagination.pageSize,
          },
        });
      }
    },
    onSearch() {
	
		console.log(this.searchform);
		
      if (this.searchform.s_employee_id == "" && this.hasWritePermission) {
        notification.open({
          message: "Please Select An Employee",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
        return;
      }

      /*
		if(this.searchform.year == ""){
			
			notification.open({
						message: 'Please Select a Year',
						placement: "topRight",
						duration: process.env.VUE_APP_NOTIFICATION_DURATION,
						style: {
						  background: process.env.VUE_APP_WARNING_COLOR,
						},
					});
					
			return;		
		}
		*/
      
	  /*if (this.searchform.year !== "" && this.searchform.month == "") {
        notification.open({
          message: "Please Select a Month",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
        return;
      }*/

      // this.pagination.current = 1;

      var params = {
        params: {
          s_employee_id: this.searchform.s_employee_id,
          month: this.searchform.month,
		  s_leave_definition_id : this.searchform.s_leave_definition_id,
          year: this.searchform.year,
          // page: this.pagination.current,
          // per_page: this.pagination.pageSize,
        },
      };
      this.loadCommonData(params);
    },
    // handleTableChange(pagination) {
    //   const page = (pagination && pagination.current) || 1;
    //   const pageSize =
    //     (pagination && pagination.pageSize) || this.pagination.pageSize;

    //   this.pagination.current = page;
    //   this.pagination.pageSize = pageSize;
    // },
    loadCommonData(params) {
      console.log("common data loading called..");

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/leaves/leavedefinitionreport", params)
        .then((response) => {
		
			
			if (response?.data?.data?.data?.[0]?.leave_summary) {
			  this.data2 = response.data.data.data[0].leave_summary;
			} else {
			  console.warn('leave_summary not found in response');
			  this.data2 = {};
			}
			
			this.tableyear = response.data.selected_year;
			this.tablemonth = response.data.selected_month;

          //this.totaldays = response.data.days
          

          // const lastPage = Math.max(
          //   1,
          //   Math.ceil(this.pagination.total / this.pagination.pageSize)
          // );
          // if (this.pagination.current > lastPage) {
          //   this.pagination.current = lastPage;
          // }

          console.log(this.data2);

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    updatePerPage() {
      console.log(this.pagination.pageSize);
      var params = {
        params: { per_page: this.pagination.pageSize },
      };
      this.loadCommonData(params);
    },
    loadAllEmployees(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/allemployees", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          //this.employee_list = response.data.data;

          console.log(response.data.data);

          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
	loadAllLeavetype(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/leave-definition/all", params)
        .then((response) => {
		
		//	console.log('Leave Definition');
         // 	console.log(response.data.data);

          for (let i = 0; i < response.data.data.length; i++) {
            this.leavedef_list.push({
              id: response.data.data[i].id,
              text: response.data.data[i].name,
            });
          }
		  

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    setupImageClickHandlers() {
      document.addEventListener("click", (event) => {
        if (event.target.closest(".pin-icon")) {
          event.preventDefault();
          const imageUrl = event.target.closest(".pin-icon").dataset.imageurl;
          this.handleImageClick(imageUrl);
        }
      });
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", {
        module: "leave_report",
        action: "read",
      })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", {
        module: "leave_report",
        action: "write",
      })
      .then((response) => {
        this.hasWritePermission = null;
        this.$nextTick(() => {
          this.hasWritePermission = response === "true";
          if (!this.hasWritePermission) {
            this.searchform = {
              s_employee_id: "",
              month: currentMonth,
			  s_leave_definition_id : "",
              year: currentYear.toString(),
            };
            var params = {
              params: {
                s_employee_id: this.searchform.s_employee_id,
                month: this.searchform.month,
				s_leave_definition_id : this.searchform.s_leave_definition_id,
                year: this.searchform.year,
                per_page: this.pagination.pageSize,
              },
            };
            this.loadCommonData(params);
          }
        });
      });

    this.$store
      .dispatch("userPermissions", {
        module: "leave_report",
        action: "export",
      })
      .then((response) => {
        this.hasExportPermission = null;
        this.$nextTick(() => {
          this.hasExportPermission = response === "true";
        });
      });

    var params = {
      params: { per_page: this.pagination.pageSize },
    };
    //this.loadCommonData(params);

    this.loadAllEmployees([]);
    this.loadAllLeavetype([]);
    this.setupImageClickHandlers();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.setupImageClickHandlers);
  },
  computed: {
    originalColumn() {
      return this.columns_.filter((column) => column.visibility);
    },
    paginatedData() {
      if (!this.data2 || !this.data2.length) return [];
      const start = (this.pagination.current - 1) * this.pagination.pageSize;
      return this.data2.slice(start, start + this.pagination.pageSize);
    },
  },
};
</script>
<style scoped>
.punch-time {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
